import { LineWeight } from '@mui/icons-material'
import { StyleRules } from '@mui/styles'

const stylesheet: StyleRules = {
  topBar: {
    height: '60px !important',
    padding: '1rem 1rem !important',
    background: 'var(--color-paper) !important',
    borderLeft: '0.5px solid var(--color-border-light) !important',
  },
  fontSizeSmall: {
    fontSize: '1rem !important',
  },
  email: {
    padding: '0.625rem !important',
  },
  itemTwo: {
    marginRight: '1rem !important',
    padding: '0.625rem !important',
  },
  itemTwo1: {
    marginRight: '1rem !important',
    background: 'var(--color-attention-bg-strong) !important',
    color: 'var(--color-attention-text) !important',
    padding: '0.625rem !important',
  },
  itemThree: {
    padding: '0.625rem !important',
  },
  ageGenderMrn: {
    height: '1.125rem !important',
    fontSize: '0.8125rem !important',
    textDecoration: 'none solid rgb(120, 120, 120) !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
    width: '15% !important',
    position: 'absolute',
  },
  separator: {
    width: '0.188rem !important',
    fontSize: '0.75rem !important',
    color: 'var(--color-text-muted) !important',
    textDecoration: 'none solid rgb(130, 130, 130) !important',
    textAlign: 'right',
    display: 'inline-block !important',
    marginRight: '10px !important',
  },
  topBarDetails: {
    display: 'flex !important',
    fontSize: '0.8rem !important',
    color: 'var(--color-text-primary) !important',
    fontWeight: 'bold !important',
    textDecoration: 'none solid rgb(120, 120, 120) !important',
    whiteSpace: 'break-spaces',
  },

  avatarPic: {
    width: '2.5rem !important',
    height: '2.5rem !important',
    borderRadius: '10px !important',
    border: '0.18rem solid #CBC7C780',
  },
  topBar1: {
    height: '6rem !important',
    paddingLeft: '0.938rem !important',
  },
  patientName: {
    height: '1.625rem !important',
    display: 'inline !important',
    fontSize: '1.25rem !important',
    fontWeight: 'bold !important',
  },
  topBarHeads: {
    fontSize: '0.8125rem !important',
    display: 'inline-block !important',
    height: '18px !important',
  },
  topBarDetails1: {
    fontSize: '0.8rem !important',
    height: '17px !important',
    textDecoration: 'none solid rgb(120, 120, 120) !important',
    margin: '0 0.5rem 0 0 !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
  },
  patientNameTop: {
    height: '1.4rem !important',
    fontSize: '1rem !important',
    fontWeight: 'bold !important',
    letterSpacing: '0rem !important',
  },
  topBarNotif: {
    display: 'flex !important',
    height: '3.125rem !important',
    backgroundColor: '#F0F1F2 !important',
    borderRadius: '0.25rem !important',
    opacity: '1 !important',
    float: 'right',
  },
  topBarNot: {
    padding: '10px 0 10px 0 !important',
    marginRight: '1rem !important',
    float: 'right',
  },
  topBarIcon: {
    color: '#dd9614 !important',
  },
  topBarIconOut: {
    borderRadius: '50% !important',
    border: '3px solid #dd9614 !important',
    width: '1.438rem !important',
    height: '1.438rem !important',
    margin: '0.75rem 0 0 1.25rem !important',
  },
  topBarNotifVal: {
    margin: '0.75rem 0.5rem 0.75rem 0.5rem !important',
    fontSize: '0.75rem !important',
    paddingTop: '0.5rem !important',
    fontWeight: 'normal !important',
    lineHeight: '1rem !important',
    color: 'var(--color-text-secondary) !important',
  },
  topBarNotifSat: {
    fontSize: '0.75rem !important',
    fontWeight: 'normal !important',
    lineHeight: '0.75rem !important',
    color: 'var(--color-text-secondary) !important',
  },
  notVal: {
    color: 'var(--color-primary) !important',
  },
  notVal1: {
    color: 'var(--color-text-secondary) !important',
    fontSize: '1rem !important',
    fontWeight: 'bold !important',
  },
  notVal2: {
    color: 'var(--color-error) !important',
  },
  topTHeader: {
    fontSize: '1rem !important',
  },
  subHeader: {
    color: 'var(--color-text-primary) !important',
    fontSize: '0.7rem !important',
    fontWeight: 500,
    width: '100% !important',
    lineHeight: '0.65rem !important',
    letterSpacing: '0.001rem !important',
  },
  topHead: {
    display: 'flex !important',
    padding: '0.75rem 0 0.375rem 0 !important',
  },
  topHead1: {
    background: 'var(--color-paper) !important',
  },
  journeyHeader: {
    padding: '1rem 2rem !important',
    background: 'var(--color-paper) !important',
    boxShadow: '0px 0px 6px #00000029 !important',
    opacity: 1,
    display: 'flex !important',
    justifyContent: 'flex-start !important',
    alignItems: 'flex-end !important',
    width: 'inherit !important',
    maxHeight: '25rem',
    overflow: 'auto !important',
  },
  timelineBox: {
    padding: '1rem',
    // background:
    //   'linear-gradient(#FFFFFF 25%,#F2F2F2 26%, #F2F2F2 48%, #FFFFFF 40%) !important',
    width: 'inherit !important',
    height: '9.5rem !important',
    minWidth: 'fit-content !important',
  },
  journeyMedList: {
    width: '100% !important',
    padding: '0rem 0.2rem 0rem 0.2rem !important',
  },
  journeyMedStatus: {
    height: '1rem !important',
    fontSize: '0.5rem !important',
    lineHeight: '0.7rem !important',
    paddingRight: '0.15rem',
    overflow: 'hidden',
  },
  dateInfo: {
    display: 'flex !important',
    justifyContent: 'flex-end !important',
    alignItems: 'flex-start !important',
    flexDirection: 'column',
    width: '10rem !important',
  },
  dateBox: {
    color: 'var(--color-text-secondary) !important',
    backgroundColor: 'var(--color-paper)',
    fontSize: '0.5rem !important',
    minWidth: '0.1rem !important',
    marginTop: '0.3rem !important',
    minHeight: '0.7rem !important',
    height: '10% !important',
  },
  activeDateline: {
    borderLeft: '0.1rem dotted #f5842e !important',
    paddingRight: '0.1rem',
  },
  activeDate: {
    color: '#fff !important',
    fontSize: '8px !important',
    background: '#f5842e !important',
    height: '1rem !important',
    left: '-6% !important',
    position: 'relative',
    '& span': {
      padding: '0rem 0.2rem !important',
    },
  },
  testBox: {
    height: '35% !important',
    width: 'inherit !important',
  },
  stageBorder: {
    borderLeft: '0.1rem solid #CBCBCB !important',
  },
  testInfoBox: {
    left: '-40% !important',
    top: '0 !important',
    width: '8.5rem !important',
    background: 'var(--color-paper) !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end !important',
    alignItems: 'center !important',
    position: 'relative',
  },
  medicineBox: {
    height: '15% !important',
    width: 'inherit !important',
    diplay: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'flex-start !important',
    padding: '0.2rem 0rem !important',
  },
  medicineInfo: {
    height: '15% !important',
    color: '#707070 !important',
    fontSize: '9px !important',
  },
  mediChange: {
    width: '0.59rem !important',
    fill: '#958C8C !important',
  },
  medicineInfoBox: {
    left: '-40% !important',
    top: '44% !important',
    width: '8.5rem !important',
    position: 'relative',
    backgroundColor: 'var(--color-paper)',
    display: 'flex',
    flexDirection: 'column',
  },
  stageTimelineBox: {
    height: '18% !important',
  },
  stageCircle: {
    width: '0.6rem !important',
    color: 'green',
    left: '-10%',
    top: '-50%',
    position: 'relative',
  },
  stageDate: {
    top: '-75%',
    position: 'relative',
    left: '-51% !important',
  },
  actionBox: {
    height: '20% !important',
    width: 'inherit !important',
  },
  actionInfoBox: {
    left: '-40% !important',
    top: '-1rem !important',
    textAlign: 'center',
    width: '8.5rem !important',
    position: 'relative',
    backgroundColor: 'var(--color-paper)',
    display: 'flex',
    flexDirection: 'column',
  },
  medTooltip: {
    backgroundColor: 'var(--color-paper) !important',
    width: 'fit-content !important',
    maxWidth: '70% !important',
    color: 'var(--color-text-primary)',
    boxShadow: '1',
    '&:hover': {
      fontWeight: '600',
      backgroundColor: 'honeydew !important',
    },
  },
  actionLabel: {
    fontSize: '0.55rem !important',
    lineHeight: '1.1 !important',
    verticalAlign: 'text-top !important',
    wordBreak: 'break-word',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
  },
  actionIcon: {
    fill: '#3FB500 !important',
    width: '0.85rem !important',
    '&.high': {
      fill: 'blue !important',
    },
    '&.low': {
      fill: 'red !important',
    },
    '&.medium': {
      fill: 'orange !important',
    },
  },
  testIcon: {
    fill: '#958C8C !important',
    width: '0.85rem !important',
  },
  medicineIcon: {
    fill: '#958C8C',
    width: '0.6rem !important',
    height: '0.65rem !important',
    transform: 'rotate(140deg) !important',
    marginBottom: '-0.1rem !important',
    paddingRight: '0.28rem',
  },
  medEvalIcon: {
    fill: '#958C8C',
    width: '0.55rem !important',
    height: '0.55rem !important',
    paddingRight: '0.08rem',
  },
  downArrowIcon: {
    top: '82% !important',
    left: '-69% !important',
    width: 'auto !important',
    height: '2rem !important',
    position: 'relative',
    zIndex: 1,
    opacity: 1,
    '&:hover': {
      fill: '#52504F !important',
      cursor: 'pointer !important',
    },
  },
  timeline: {
    height: '0.3rem !important',
    borderLeft: '0.1rem solid #B2AFAF !important',
  },
  timelineBg: {
    width: 'inherit !important',
    borderBottom: '0.1rem dotted #CBCBCB !important',
  },
  pastTimelineBg: {
    width: 'inherit !important',
    borderBottom: '2px solid #3FB500 !important',
  },
  topNameDet: {
    padding: '0 0 0 0.625rem !important',
    width: '100% !important',
    overflow: 'hidden !important',
    display: 'inline !important',
    '&:hover': {
      cursor: 'default !important',
    },
  },
  iconBase: {
    width: '1em !important',
    height: '1em !important',
    padding: '0 !important',
  },
  iconBaseBorder: {
    padding: '0.1rem !important',
  },
  emptyImg: {
    width: '3rem !important',
    padding: '0rem 1rem !important',
  },
  tablePadding: {
    padding: '0.3rem !important',
  },
  tablePaddingPList: {
    padding: '0.1rem 0.1rem 0.1rem 0.3rem !important',
    lineHeight: '1 !important',
    // border: 'none !important',
  },
  // tablePaddingPListHeader: {
  //   padding: '0.4rem !important',
  //   border: 'none !important',
  //   backgroundColor: '#fff !important',
  // },
  tablePaddingPListSelected: {
    padding: '0.4rem !important',
    border: 'none !important',
    backgroundColor: 'var(--color-attention-bg-alt) !important',
    color: 'var(--color-attention-text) !important',
  },
  tablePaddingPT: {
    padding: '0.1rem 0.1rem 0.1rem 0.2rem !important',
  },
  tableIconPaddingPT: {
    padding: '0.5rem 0.25rem 0.3rem 0.15rem !important',
  },
  targetIcons: {
    fontSize: '14px !important',
    padding: '0.15rem !important',
  },
  tableHeader: {
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    padding: '0.2rem 0.2rem 0.1rem 0.2rem !important',
    fontSize: '0.65rem !important',
  },
  taskTableHeader: {
    wordWrap: 'break-word',
    padding: '0.1rem 0.2rem 0.1rem 0.5rem !important',
    fontSize: '0.7rem !important',
  },
  taskTableHeaderTitle: {
    fontWeight: '500 !important',
    fontSize: '0.7rem !important',
  },
  closeBtn: {
    color: 'var(--color-primary) !important',
  },
  tableReconcileHeader: {
    verticalAlign: 'top !important',
    borderRight: '1px solid var(--color-border-light) !important',
  },
  confirmCardBackground: {
    backgroundColor: 'var(--color-attention-bg) !important',
    color: 'var(--color-attention-text) !important',
    '& .MuiTableCell-root': {
      backgroundColor: 'var(--color-attention-bg) !important',
      color: 'var(--color-attention-text) !important',
    },
    '& .MuiTypography-root': {
      color: 'var(--color-attention-text) !important',
    },
    '&:hover': {
      cursor: 'pointer !important',
    },
  },
  recommendedBackground: {
    backgroundColor: 'var(--color-recommended-bg) !important',
    // Default text to white for recommended cards
    '& .MuiTypography-root': {
      color: '#FFFFFF !important',
    },
    // Medication name: first subtitle2 with desc class in the card
    '& $programCardContent > $initialFlexwrap:first-child > .MuiGrid-item:first-child $desc': {
      color: 'var(--color-highlight) !important',
    },
    // Second medication name (uptitrate "Start" line) with descleftHeader class
    '& $programCardContent $descleftHeader': {
      color: 'var(--color-highlight) !important',
    },
  },
  dependentQuestionnarie: {
    backgroundColor: '#b3d65370 !important',
  },
  recommendedRefDisconBackground: {
    backgroundColor: '#373534a8 !important',
    border: '0.1rem solid #DB2323 !important',
  },
  recommendedDisconBackground: {
    backgroundColor: '#373534a8 !important',
  },
  corfirmButtonStyle: {
    color: 'var(--color-primary) !important',
    padding: '0.1rem !important',
    textTransform: 'none',
    '& .MuiSvgIcon-root': {
      fill: 'var(--color-primary) !important',
    },
  },
  corfirmDisabledButtonStyle: {
    color: 'var(--color-text-muted) !important',
    padding: '0.1rem !important',
    textTransform: 'none',
  },
  corfirmCancelButtonStyle: {
    padding: '0.2rem !important',
    textTransform: 'none',
    color: 'var(--color-primary) !important',
  },
  boxBorder: {
    background: 'transparent linear-gradient(180deg, #E1E1E1B3 0%, #F2F2F2 34%, #FFFFFF 78%, #FFFFFF 100%) 0% 0% no-repeat padding-box !important',
    backgroundSize: '100% 5px !important',
    minHeight: '0.10rem',
  },
  dialogBtnStyle: {
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'var(--color-primary) !important',
      color: 'white !important',
      border: 'var(--color-primary) solid .1rem !important',
    },
    color: 'var(--color-text-primary) !important',
    border: 'var(--color-border-light) solid .1rem !important',
    padding: '0.2rem !important',
  },
  questionButtonStyle: {
    justifyContent: 'space-around !important',
    display: 'flex !important',
    flexWrap: 'wrap',
    width: '100% !important',
    borderTop: 'var(--color-border-light) solid 1px !important',
  },
  questionFullButtonStyle: {
    justifyContent: 'space-around !important',
    display: 'flex !important',
    flexWrap: 'wrap',
    width: '100% !important',
    border: 'var(--color-border-light) solid 1px !important',
  },
  questionButtonWidth: {
    textTransform: 'none',
    width: '33.3% !important',
    color: 'var(--color-primary) !important',
    '&.Mui-disabled': {
      color: 'var(--color-btn-disabled-text) !important',
      opacity: 0.6,
    },
  },
  questionButtonWidth1: {
    textTransform: 'none',
    width: '50% !important',
    color: 'var(--color-primary) !important',
    '&.Mui-disabled': {
      color: 'var(--color-btn-disabled-text) !important',
      opacity: 0.6,
    },
  },

  twoButtonWidth: {
    textTransform: 'none',
    width: '50% !important',
    color: 'var(--color-primary) !important',
    '&.Mui-disabled': {
      color: 'var(--color-btn-disabled-text) !important',
      opacity: 0.6,
    },
  },
  OneButtonWidth: {
    textTransform: 'none',
    width: '100% !important',
    color: 'var(--color-primary) !important',
    '&.Mui-disabled': {
      color: 'var(--color-btn-disabled-text) !important',
      opacity: 0.6,
    },
  },
  questionCardContent: {
    padding: '0px !important',
    border: 'var(--color-primary) solid 0.1rem !important',
  },
  questionCardSubContent: {
    padding: '0px !important',
  },
  questionSubmitAnsButton: {
    padding: '2px 5px !important',
    textTransform: 'none',
    backgroundColor: 'transparent !important',
    color: 'var(--color-text-primary) !important',
    borderColor: 'var(--color-border-light) !important',
    '& .MuiTypography-root': { color: 'inherit !important' },
    '&:hover': {
      backgroundColor: 'var(--color-background-subtle) !important',
      borderColor: 'var(--color-text-secondary) !important',
    },
    '&:active': {
      backgroundColor: 'var(--color-btn-selected-bg) !important',
      color: 'var(--color-btn-selected-text) !important',
    },
  },
  chipDefault: {
    margin: '0.3rem !important',
    textTransform: 'none',
    height: '25px !important',
    fontWeight: 500,
    color: 'var(--color-text-secondary) !important',
  },
  chipSearch: {
    height: '20px !important',
    width: 'fit-content !important',
    margin: '2px !important',
    backgroundColor: 'var(--color-paper)',
    fontSize: '0.7rem !important',
    '& .MuiChip-deleteIcon': {
      fontSize: '0.75rem !important',
    },
  },
  questionSubmitAnsButtonActive: {
    '&&': {
      padding: '2px 5px !important',
      textTransform: 'none',
      backgroundColor: 'var(--color-btn-selected-bg) !important',
      color: 'var(--color-btn-selected-text) !important',
      '&:hover': {
        backgroundColor: 'var(--color-btn-selected-bg) !important',
        color: 'var(--color-btn-selected-text) !important',
      },
    },
  },
  chipSelect: {
    backgroundColor: 'var(--color-primary) !important',
    height: '25px !important',
    color: 'white !important',
    fontWeight: 500,
    margin: '0.3rem !important',
    '&:focus': {
      backgroundColor: 'var(--color-primary-dark) !important',
    },
    '&:hover': {
      backgroundColor: 'var(--color-primary-dark) !important',
    },
  },
  questionHeaderSection: {
    borderBottom: 'var(--color-border-light) solid 1px !important',
    padding: '0.5rem  !important',
  },
  questionHeaderOtherMedSection: {
    padding: '0.5rem !important',
  },
  questionHeaderSection1: {
    display: 'inline-block !important',
    verticalAlign: 'middle !important',
  },
  questionHeaderSection2: {
    display: 'inline-block !important',
    width: 'calc(100% - 50px) !important',
    verticalAlign: 'middle !important',
  },
  backIcon: {
    color: 'var(--color-primary-dark) !important',
    display: 'inline-block !important',
    margin: '5px 5px 0 0 !important',
    border: '2px solid var(--color-primary-dark) !important',
    borderRadius: '24px !important',
    height: '24px !important',
    width: '24px !important',
    verticalAlign: 'middle !important',
    padding: 0,

    '& span': {
      width: '20px !important',
      height: '20px !important',
    },
  },
  medicineSubmitAnsButton: {
    '&:active': {
      backgroundColor: '#151cffa6 !important',
      color: 'white !important',
    },
    background: 'var(--color-paper) !important',
    marginRight: '1rem !important',
    height: '1.5rem !important',
    textTransform: 'none',
    border: '0.1rem solid rgb(0 0 255 / 25%) !important',
  },
  medicineSubmitAnsButtonActive: {
    '&:hover': {
      backgroundColor: '#151cffa6 !important',
      color: 'white !important',
    },
    backgroundColor: '#151cffa6 !important',
    color: 'white !important',
    textTransform: 'none',
    border: '0.1rem solid rgb(0 0 255 / 25%) !important',
  },
  decisionView: {
    padding: '1rem !important',
  },
  fullWidth: {
    width: '100% !important',
  },
  halfWidth: {
    width: '50% !important',
  },
  notesCancelBtn: {
    color: 'var(--color-text-secondary) !important',
    fontWeight: 'bold !important',
    textTransform: 'none',
  },
  notesSaveBtn: {
    color: 'var(--color-primary) !important',
    fontWeight: 'bold !important',
    textTransform: 'none',
  },
  bottomBtn: {
    display: 'flex !important',
    padding: '0rem !important',
  },
  decisionBtn: {
    fontSize: '0.6rem !important',
    fontWeight: 'bold !important',
    color: 'var(--color-primary) !important',
    width: '100% !important',
    borderRight: '1px solid var(--color-border-light) !important',
    borderTop: '1px solid var(--color-border-light) !important',
  },
  takingBorder: {
    padding: '1rem !important',
  },
  bootmBtn: {
    width: '33.3% !important',
    color: 'var(--color-primary) !important',
    fontSize: '0.7rem !important',
    fontWeight: 'bold !important',
    borderRight: '1px solid var(--color-border-light) !important',
    borderTop: '1px solid var(--color-border-light) !important',
  },
  diffBorder: {
    paddingLeft: '1rem !important',
    paddingRight: '1rem !important',
    paddingBottom: '1rem !important',
  },

  programTargetFirstTableCell: {
    borderBottom: 'none !important',
    padding: '0rem !important',
  },
  tableCellEdit: {
    borderBottom: 'none !important',
    padding: '0 0 0.5rem 0 !important',
  },
  tableCellEditTop: {
    borderBottom: 'none !important',
    padding: '0 0.2rem 0.5rem 0.2rem !important',
    verticalAlign: 'top !important',
  },
  tableCellEditTopRB: {
    borderBottom: 'none !important',
    padding: '0 0.2rem 0.5rem 0.2rem !important',
    verticalAlign: 'top !important',
    borderRight: '1px solid var(--color-border-light) !important',
  },
  grayScheduleCardLayout: {
    cursor: 'pointer !important',
    border: '1px solid var(--color-border-light) !important',
  },
  selectedScheduleCardLayout: {
    cursor: 'pointer !important',
    backgroundColor: 'var(--color-paper) !important',
    border: '#32a332 solid 0.1rem !important',
  },
  scheduleCardLayout: {
    cursor: 'pointer !important',
    backgroundColor: 'var(--color-paper) !important',
    border: '#ea9864 solid 0.1rem !important',
  },
  nonSelectedScheduleCardLayout: {
    backgroundColor: '#aca8a852 !important',
    border: '#aca8a852 solid 0.1rem !important',
  },
  selectedScheduleCardMargin: {
    marginBottom: '1rem',
  },
  programTargetTableCell: {
    borderBottom: '1px solid rgba(224, 224, 224, 1) !important',
    padding: '0.1rem 0.1rem 0.1rem 0rem !important',
  },
  programTargetLastTableCell: {
    borderBottom: 'none !important',
    padding: '0.1rem 0.1rem 0.1rem 0rem !important',
  },
  programTargetFooterStyle: {
    justifyContent: 'space-around !important',
    display: 'flex !important',
    flexWrap: 'wrap',
    width: '100% !important',
    borderRight: 'none !important',
    backgroundColor: 'var(--color-paper) !important',
    borderTop: '1px solid var(--color-border-light) !important',
    '&.MuiButtonGroup-root': {
      borderRadius: '0 0 0.25rem 0.25rem !important',
    },
  },
  ProgramTargetHistoryBy: {
    color: 'var(--color-primary) !important',
  },
  borderLayout: {
    border: '0.1rem solid var(--color-primary) !important',
  },

  toggleButtonItem: {
    '& >button': {
      '& >span': {
        lineHeight: '1.2 !important',
      },
      height: '28px !important',
      borderRadius: '4px 4px 4px 4px !important',
      borderLeft: '1px solid !important',
      borderRight: '1px solid !important',
      borderColor: '#77AEDD !important',
      textTransform: 'none',
      width: 'fitContent !important',
      margin: '0 5px 0 0 !important',

      '&.Mui-selected': {
        backgroundColor: '#77AEDD !important',
        color: 'white !important',
      },
      '&:hover': {
        backgroundColor: '#77AEDD !important',
        color: 'white !important',
        borderColor: '#77AEDD !important',
      },
      '&:focus': {
        backgroundColor: '#77AEDD !important',
        color: 'white !important',
        borderColor: '#77AEDD !important',
      },
    },
  },
  textLabel: {
    padding: '0.2rem 0 0.2rem 0.625rem !important',
    fontSize: '0.75rem !important',
    color: 'var(--color-text-primary) !important',
    boxSizing: 'border-box',
  },

  medicationTextAre: {
    display: 'block !important',
    margin: '19px 0 26px !important',
    padding: '4px 6px !important',
    height: '80px !important',
    width: '100% !important',
    fontSize: '0.8125rem !important',
    boxSizing: 'border-box',
    color: '#999999 !important',
    borderColor: '#77AEDD !important',
    '&:hover': {
      borderColor: '#77AEDD !important',
    },
    '&:focus': {
      borderColor: '#77AEDD !important',
    },
  },
  buttonLabel: {
    width: '100% !important',
    boxSizing: 'border-box',
    maxWidth: '100% !important',
    borderBottomRightRadius: '12px !important',
    borderBottomLeftightRadius: '12px !important',
    borderTopRightRadius: '0 !important',
    borderTopLeftRadius: '0 !important',

    '& >button': {
      border: '#CBCBCB 1px solid !important',
      borderBottomRightRadius: '12px !important',
      borderBottomLeftightRadius: '12px !important',
      borderTopRightRadius: '0 !important',
      borderTopLeftRadius: '0 !important',
      marginBottom: '-1px !important',
      fontSize: '1rem !important',
      color: 'var(--color-primary) !important',
      fontWeight: '700 !important',
      width: '100% !important',
      maxWidth: '100% !important',
    },
  },
  medicineBorder: {
    border: 'var(--color-primary) 0.1rem solid !important',
    borderRadius: '0.75rem !important',
  },
  bottomBorder: {
    paddingBottom: '0.5rem !important',
    borderBottom: '0.1rem solid #8080801f !important',
    display: 'block !important',
  },
  tooltip: {
    height: '10px !important',
    padding: '0px !important',
    fontSize: '1.25rem !important',
    color: '#ffffff !important',
  },
  measurementsText: {
    textAlign: 'left',
    letterSpacing: '0px !important',
    color: 'var(--color-text-primary) !important',
    opacity: 1,
  },
  measurementsSubText: {
    fontSize: '0.75rem !important',
    color: '#999999 !important',
    float: 'right',
  },
  measurementTextBox: {
    paddingTop: '10px !important',
    '& div': {
      width: '100% !important',
    },
  },
  measurementInput: {
    width: '40% !important',
    paddingLeft: '5px !important',
  },
  measurementInputOuter: {
    border: '1px solid #D3D3D3 !important',
    borderRadius: '3px !important',
    opacity: 1,
    '& ::before': {
      content: 'none !important',
    },
  },
  measurementDateBlock: {
    background: 'var(--color-paper) 0% 0% no-repeat padding-box !important',
    border: '1px solid var(--color-border-medium) !important',
    borderRadius: '4px !important',
    opacity: '1 !important',
    marginTop: '12px !important',
    padding: '10px !important',
    '& span': {
      color: 'var(--color-text-primary) !important',
    },
  },
  modalAtCenter: {
    top: '33% !important',
    left: '33% !important',
    position: 'absolute',
  },
  cardLeftFooter: {
    '&>*:not(:last-child)': {
      marginRight: '0.2rem !important',
    },
  },
  tooltip1: {
    textAlign: 'left',
    fontSize: '0.75rem !important',
    letterSpacing: '0rem !important',
    opacity: '1 !important',
    paddingTop: '0.5rem !important',
  },
  tooltip2: {
    textAlign: 'left',
    letterSpacing: '0rem !important',
    color: 'var(--color-text-primary) !important',
    opacity: '1 !important',
  },
  checkBoxShadow: {
    background: 'rgba(228, 230, 232, 0.4) !important',
  },
  header2: {
    textAlign: 'left',
    fontSize: '0.75rem !important',
    letterSpacing: '0rem !important',
    color: 'var(--color-text-primary) !important',
    opacity: '1 !important',
    paddingBottom: '0.5rem !important',
  },
  addnew: {
    '&:hover': {
      opacity: 1,
      color: 'var(--color-primary) !important',
    },
    textAlign: 'left',
    letterSpacing: '0rem !important',
    color: 'var(--color-text-primary) !important',
    opacity: '0.7 !important',
  },
  sfBtn: {
    backgroundColor: '#F08230 !important',
    fontSize: '11px !important',
    color: 'white !important',
    '&:hover': {
      background: 'var(--color-highlight) !important',
    },
  },
  sfBtnContainer: {
    margin: '15px 0 10px 0 !important',
  },
  headerTitle: {
    fontSize: '0.75rem !important',
    // letterSpacing: '0.001rem !important',
  },
  expressModeBtn: {
    color: 'var(--color-text-secondary) !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
    marginLeft: '0.1rem',
    fontSize: '0.7rem !important',
    letterSpacing: 0,
    '&:hover': {
      color: 'var(--color-text-primary) !important',
      backgroundColor: 'rgba(0, 0, 0, 0.0) !important',
    },
  },
  activeBtn: {
    textTransform: 'none',
    color: 'var(--color-primary) !important',
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: '0.1rem !important',
    fontSize: '0.7rem !important',
    letterSpacing: 0,
    // cursor: 'pointer',
    '&:hover': {
      color: 'var(--color-primary) !important',
      backgroundColor: 'rgba(0, 0, 0, 0.0) !important',
    },
  },
  manageReportBtn: {
    color: 'var(--color-text-primary) !important',
    fontWeight: 420,
    paddingLeft: '3rem !important',
    display: 'inline-block !important',
    '&:hover': {
      color: 'var(--color-primary) !important',
      cursor: 'pointer !important',
    },
  },
  addIcon: {
    display: 'inline !important',
    paddingLeft: '0.5rem !important',
  },
  cardBox: {
    width: '100% !important',
    background: 'var(--color-paper) 0% 0% no-repeat padding-box !important',
    border: '0.1rem solid var(--color-primary) !important',
    borderRadius: '6px !important',
    opacity: 1,
    marginBottom: '0.5rem !important',
    fontSize: '0.7rem !important',
  },
  cardLabInfo: {
    borderTop: '1px solid var(--color-border-light) !important',
    padding: '0.4rem 0.8rem 0.3rem 0.2rem !important',
  },
  cardLabList: {
    paddingLeft: '0.5rem !important',
  },
  cardLabRange: {
    verticalAlign: 'middle !important',
    fontSize: '0.7rem !important',
  },
  cardLabIcon: {
    fill: '#999999 !important',
    width: '14px !important',
    verticalAlign: 'middle !important',
  },
  cardLabvalue: {
    height: '1.8rem !important',
    fontSize: '0.7rem !important',
  },
  cardLabButton: {
    width: '40% !important',
    color: 'var(--color-primary) !important',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.8rem !important',
  },
  cardLabNotes: {
    width: '56% !important',
    fontSize: '0.7rem !important',
    backgroundColor: 'var(--color-paper) !important',
  },
  cardLabDate: {
    height: '2rem !important',
    fontSize: '0.7rem !important',
  },
  datePicker: {
    width: '100% !important',
    margin: '10px 0 20px 0 !important',
  },
  overflowTextTwoLine: {
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
    display: '-webkit-box !important',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    fontSize: '0.8rem !important',
    color: 'var(--color-text-primary) !important',
    fontWeight: 'bold !important',
    textDecoration: 'none solid rgb(120, 120, 120) !important',
  },
  customCard: {
    width: '100%',
  },
  customCard1: {
    lineHeight: '1 !important',
    padding: '0px !important',
    textAlign: 'center',
    width: '100% !important',
    fontSize: '0.65rem !important',
  },
  chartBorder: {
    borderBottom: '0.5px solid var(--color-border-medium) !important',
  },
  cardValue: {
    fontSize: '0.65rem !important',
    lineHeight: '0.6rem !important',
  },
  subTitle: {
    fontSize: '0.65rem !important',
    fontWeight: '500 !important',
    lineHeight: '0.6rem !important',
    letterSpacing: '0.00714em !important',
    color: 'var(--color-text-primary) !important',
  },
  subTitleDisabled: {
    fontSize: '0.7rem !important',
    fontWeight: '500 !important',
    letterSpacing: '0.00714em !important',
    color: 'var(--color-text-muted) !important',
    cursor: 'default !important',
  },
  subHeaderTitle: {
    fontSize: '0.65rem !important',
    lineHeight: '0.6rem !important',
    // color: 'rgba(0, 0, 0, 0.5)',
    fontWeight: 400,
    '& h6': {
      fontSize: '0.65rem !important',
      lineHeight: '0.6rem !important',
      // color: 'rgba(0, 0, 0, 0.5)',
      fontWeight: 400,
    },
  },
  cardDate: {
    fontSize: '0.65rem !important',
    color: 'var(--color-text-secondary) !important',
    fontWeight: 400,
    lineHeight: '1 !important',
  },
  addCircleButton: {
    marginRight: '0.2rem !important',
    fontSize: '0.6rem !important',
    letterSpacing: '0px',
    cursor: 'pointer',
  },
  closeIcon: {
    height: '1.25rem !important',
    width: '1.25rem !important',
    color: '#757575 !important',
    float: 'right',
    paddingTop: '0.5rem !important',
    paddingRight: '0.5rem !important',
    '&:hover': {
      fill: '#52504F !important',
      cursor: 'pointer !important',
    },
  },
  monitorIcon: {
    width: '20px !important',
    height: '20px !important',
    fill: 'var(--color-primary) !important',
    paddingRight: '0.3rem',
  },
  extendMonitorErr: {
    paddingLeft: '16.5% !important',
    paddingTop: '0.5rem',
  },
  topTextOC: {
    color: '#999999 !important',
  },
  programTargetBox: {
    width: '100% !important',
    //marginBottom: '2px'
  },
  errorText: {
    color: 'red !important',
  },
  PSCbuttons: {
    '&.MuiButton-root': {
      padding: '4px 30px !important',
    },
  },
  questionPSCButton: {
    padding: '0.25rem !important',
    textTransform: 'none',
    '&:active': {
      backgroundColor: '#000000 !important',
      color: 'white !important',
    },
  },
  questionPSCButtonActive: {
    padding: '0.25rem !important',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'var(--color-primary-dark) !important',
      color: 'white !important',
    },
    backgroundColor: 'var(--color-primary-dark) !important',
    color: 'white !important',
  },
  questionPSCNoButton: {
    margin: '0px 0rem  0rem 1.5rem !important',
  },
  clearBtn: {
    color: 'var(--color-text-primary) !important',
    cursor: 'pointer !important',
  },
  referralBackground: {
    border: '0.1rem solid var(--color-referral-border) !important',
    backgroundColor: 'var(--color-referral-bg) !important',
    borderRadius: '4px',
  },
  reconcileMedListBox: {
    maxHeight: '62vh',
  },
  reconcilHeaderBox: {
    height: '400px',
    overflow: 'scroll',
    marginTop: '4px',
  },
  addMeasurementBox: {
    paddingTop: '1rem',
    maxHeight: '30rem !important',
    overflowY: 'auto',
  },
  restrictMedHeaderBox: {
    minHeight: '5rem',
    maxHeight: '20rem !important',
    overflowY: 'auto',
  },
  aaFormContainer: {
    padding: '0rem 0rem 0.5rem 0.5rem !important',
    minHeight: '3.5rem',
  },
  addStartIcon: {
    fontSize: '0.7rem !important',
    marginRight: '-5px !important',
  },
  addMeasurementButton: {
    fontSize: '0.7rem',
    letterSpacing: 0,
    paddingTop: '20px !important',
    marginRight: '0px !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  reconcileHeader: {
    backgroundColor: 'var(--color-reconcile-header) !important',
    borderBottom: 'none',
  },
  reconcilePendingIcon: {
    fontSize: '1.12rem !important',
    verticalAlign: 'middle !important',
    fill: 'var(--color-primary) !important',
    paddingRight: '5px !important',
  },
  reconcileIcon: {
    fontSize: '1rem !important',
    verticalAlign: 'middle !important',
    fill: '#08ad08 !important',
    paddingRight: '5px !important',
  },
  reconcileListIcon: {
    fontSize: '0.6rem !important',
    fill: 'var(--color-text-secondary) !important',
    paddingTop: '0.155rem !important',
  },
  reconcileBg: {
    border: '0.1rem solid var(--color-reconcile-matched-border) !important',
    backgroundColor: 'var(--color-reconcile-matched-bg) !important',
    borderRadius: '4px',
  },
  reconcileDraftBg: {
    border: '0.1rem solid var(--color-attention-border) !important',
    backgroundColor: 'var(--color-attention-bg) !important',
    color: 'var(--color-attention-text) !important',
    borderRadius: '4px',
  },
  reconcileQuarantineBg: {
    border: '0.1rem solid var(--color-reconcile-quarantine-border) !important',
    backgroundColor: 'var(--color-reconcile-quarantine-bg) !important',
    borderRadius: '4px',
  },
  reconcileBgNewMedNeedConfirmation: {
    border: '0.12rem solid var(--color-reconcile-new-border) !important',
    backgroundColor: 'var(--color-attention-bg) !important',
    color: 'var(--color-attention-text) !important',
    borderRadius: '4px',
  },
  reconcileBgNewMed: {
    border: '0.12rem solid var(--color-reconcile-new-border) !important',
    backgroundColor: 'var(--color-reconcile-new-bg) !important',
    borderRadius: '4px',
  },
  overrideItemCard: {
    border: '0rem solid var(--color-override-bg) !important',
    backgroundColor: 'var(--color-override-bg) !important',
    borderRadius: '0px',
  },
  overrideBackground: {
    border: '0.1rem solid var(--color-override-border) !important',
    backgroundColor: 'var(--color-override-alt-bg) !important',
    borderRadius: '4px',
  },
  overrideTitle: {
    // &&& out-specifies the card-level `.confirmCardBackground .MuiTypography-root` rule.
    '&&&': {
      color: '#ffb573 !important',
    },
  },
  overrideTargetRow: {
    backgroundColor: 'var(--color-attention-bg-alt) !important',
    // && out-specifies the card-level `.confirmCardBackground .MuiTableCell-root` rule.
    '&& .MuiTableCell-root': {
      backgroundColor: 'var(--color-attention-bg-alt) !important',
    },
  },
  updatedTargetRow: {
    backgroundColor: 'var(--color-paper) !important',
    '&& .MuiTableCell-root': {
      backgroundColor: 'var(--color-paper) !important',
    },
  },
  carePlanBorder: {
    border: '0.1rem solid gray !important',
  },
  tooltipScroll: {
    maxHeight: '10rem !important',
    overflow: 'auto !important',
  },
  refRecomendBackground: {
    backgroundColor: '#52514F !important',
    border: '0.1rem solid #DB2323 !important',
  },
  icdBorder: {
    '&:not(:last-child)': {
      borderBottom: 'var(--color-border-light) solid 1px !important',
    },
  },
  icdActive: {
    backgroundColor: '#E1E1E1 !important',
  },
  icdDesc: {
    '&:hover': {
      cursor: 'pointer !important',
    },
  },
  icdButtons: {
    marginRight: '1rem !important',
    padding: '1rem, 0.25rem !important',
    textTransform: 'none',
  },
  dialogHeader: {
    background: 'var(--color-paper) !important',
    height: '20px !important',
  },
  dialogBtnAction: {
    textTransform: 'none',
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'var(--color-background-subtle) !important',
    },
    color: 'var(--color-text-primary) !important',
    border: 'var(--color-border-medium) solid .1rem !important',
    padding: '0.3125rem 1.625rem !important',
  },
  dialogBtnActionSelected: {
    textTransform: 'none',
    backgroundColor: 'var(--color-btn-selected-bg) !important',
    '&:hover': {
      color: 'var(--color-btn-selected-text) !important',
      backgroundColor: 'var(--color-btn-selected-bg) !important',
    },
    color: 'var(--color-btn-selected-text) !important',
    border: 'var(--color-btn-selected-border) solid .1rem !important',
    padding: '0.3125rem 1.625rem !important',
  },
  subModalBackground: {
    backgroundColor: 'var(--color-attention-bg-strong) !important',
    color: 'var(--color-attention-text) !important',
    padding: '10px 20px',
  },
  addmedicationmodal: {
    position: 'absolute',
    top: '50% !important',
    left: '50% !important',
    transform: 'translate(-50%, -50%) !important',
    width: 400,
    bgcolor: 'background.paper !important',
    border: '2px solid #000 !important',
    boxShadow: '24 !important',
    p: 4,
  },

  displayNone: {
    display: 'none !important',
  },
  backIconRestrict: {
    border: '2px solid var(--color-primary-dark) !important',
    borderRadius: '50% !important',
    color: 'var(--color-primary-dark) !important',
    padding: '0 !important',
    margin: '0.2rem 0.5rem 0 0.5rem !important',
  },
  visible: {
    visibility: 'hidden',
  },
  toxicityTableSection: {
    border: 'var(--color-border-light) solid 2px !important',
    padding: '0.5rem !important',
    '&:not(:last-child)': {
      borderBottom: 'none !important',
    },
  },
  bagdeIcon: {
    color: '#00A793 !important',
  },
  editProfileIcon: {
    marginRight: '0.5rem !important',
    '&:hover': {
      cursor: 'pointer !important',
    },
  },
  historyData: {
    borderBottom: '0.5px solid var(--color-border-medium) !important',
    borderTop: '0.5px solid var(--color-border-medium) !important',
  },
  historyTableScroll: {
    maxHeight: '20rem !important',
    overflow: 'auto !important',
  },
  measurementButton: {
    borderTop: '0.5px solid var(--color-border-medium) !important',
    backgroundColor: 'var(--color-paper) !important',
  },
  customBadge: {
    backgroundColor: '#958c8c !important',
    color: 'white !important',
  },
  wrapNote: {
    wordWrap: 'break-word',
  },
  infoIcon: {
    color: 'var(--color-text-secondary) !important',
    padding: '0rem 0rem 0rem 0.1rem !important',
  },
  desc: {
    fontSize: '0.65rem !important',
    wordBreak: 'break-word',
    lineHeight: '0.6rem !important',
    '& p': {
      fontSize: '0.65rem !important',
      lineHeight: '0.6rem !important',
    },
  },
  smallDesc: {
    fontSize: '0.6rem !important',
    wordBreak: 'break-word',
    lineHeight: '0.6rem !important',
  },
  compactCard: {
    border: 'none !important',
    alignItems: 'center !important',
    padding: '0px !important',
    marginBottom: '0px !important',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  compactOverrideCard: {
    border: 'none !important',
    alignItems: 'center !important',
    padding: '0px !important',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  compactTargetCard: {
    width: '100% !important',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  medChoicesBox: {
    padding: '0.5rem 1rem 0.5rem 1rem !important',
    maxHeight: '30rem !important',
    overflowY: 'auto',
  },
  medChoicesRecomBox: {
    padding: '0.4rem 1rem 0.5rem 1rem !important',
    // maxHeight: '30rem !important',
    // overflowY: 'auto'
  },
  medChoiceActiveBtn: {
    // color: 'var(--color-primary) !important',
    fontSize: '0.7rem !important',
    fontWeight: '500 !important',
    cursor: 'pointer',
    // '&:hover': {
    //   color: 'var(--color-primary) !important',
    //   backgroundColor: 'rgba(0, 0, 0, 0.0) !important',
    // },
  },
  medChoiceBtn: {
    fontWeight: '400 !important',
    cursor: 'pointer !important',
  },
  medChoiceCardContent: {
    margin: '0.3rem 0.8rem 0.5rem 0rem !important',
    border: 'var(--color-border-light) solid 0.1rem !important',
    boxShadow: '0px 0px 6px var(--color-shadow) !important',
  },
  compactMedCard: {
    padding: '0px !important',
    marginBottom: '2px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  compactCardContent: {
    flexWrap: 'wrap',
    width: '100% !important',
    justifyContent: 'space-between',
    flexDirection: 'row',
    // minHeight: '0.8rem !important',
    padding: '0.1rem 0.1rem 0.1rem 0.2rem !important',
    '& p': {
      fontSize: '0.65rem !important',
      // lineHeight: '0.8rem !important'
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  compactMenuCard: {
    display: 'flex !important',
    flexDirection: 'row',
    height: '1.5rem !important',
    overflow: 'hidden',
    padding: '0px 2px !important',
  },
  compactTargetMenuItem: {
    justifyContent: 'center !important',
    padding: '0px 0.05rem !important',
  },
  compactMenuItem: {
    justifyContent: 'center !important',
    padding: '0px 0.15rem !important',
  },
  corfirmCompactButtonStyle: {
    color: 'var(--color-primary) !important',
    padding: '0px !important',
    textTransform: 'none',
    '& .MuiSvgIcon-root': {
      fill: 'var(--color-primary) !important',
    },
  },
  compactMenuIcon: {
    fontSize: '12px !important',
    verticalAlign: 'middle !important',
  },
  puList: {
    display: 'list-item !important',
    listStyle: 'disc !important',
    padding: '0px !important',
    fontSize: '0.7rem',
  },
  evalContent: {
    display: 'flex !important',
    flexDirection: 'column',
    padding: '0.2rem 1rem 1rem 1rem',
  },
  evalProviderContent: {
    display: 'flex !important',
    flexDirection: 'column',
    padding: '0.2rem 1rem 0.2rem 0rem',
  },
  evalBox: {
    padding: '0.4rem 0rem 0.4rem 0.5rem',
  },
  evalSubBox: {
    paddingLeft: '0.5rem !important',
  },
  evalToxCriteria: {
    padding: '0.3rem 0 0.2rem 1rem',
  },
  evalBoxLabel: {
    color: 'var(--color-text-secondary) !important',
    fontSize: '0.7rem !important',
    fontWeight: 400,
    letterSpacing: '0.01071em',
  },
  evalBoxVal: {
    color: 'var(--color-text-secondary) !important',
    fontSize: '0.7rem !important',
    fontWeight: '410 !important',
    letterSpacing: '0.01071em',
  },
  instructionVal: {
    fontSize: '0.7rem !important',
    fontWeight: '410 !important',
    letterSpacing: '0.01071em',
  },
  alignTextCenter: {
    textAlign: 'center',
  },
  circularLoading: {
    height: '90vh !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },
  addMeasurementBtn: {
    minWidth: '20%',
    paddingRight: '0.2rem !important',
    width: 'fit-content !important',
  },
  subHeadername: {
    fontSize: '0.65rem !important',
    paddingTop: '0rem !important',
    letterSpacing: '0px',
    lineHeight: '0.8rem !important',
  },
  formControlWidth150: {
    width: '120px',
  },
  medSubSelectBtn: {
    padding: '0 0.2rem !important',
    fontSize: '0.6rem !important',
    minWidth: '2rem !important',
    left: '0.4rem !important',
    height: '1rem !important',
  },
  medSubSelectActiveBtn: {
    color: '#FFF !important',
    backgroundColor: 'var(--color-primary-dark) !important',
    borderColor: 'var(--color-primary-dark) !important',
  },
  substituteBg: {
    backgroundColor: 'var(--color-attention-bg)',
    color: 'var(--color-attention-text)',
  },
  substituteRestrictBg: {
    paddingTop: '20px !important',
    backgroundColor: 'var(--color-attention-bg)',
    color: 'var(--color-attention-text)',
  },
  substituteRestrictText: {
    color: 'var(--color-primary)',
  },

  historyLoading: {
    paddingLeft: '45% !important',
    paddingTop: '10%',
  },

  medHistoryTitles: {
    backgroundColor: 'var(--color-background-subtle) !important',
  },

  formControlStage: {
    marginTop: '-5px',
  },

  providerRecommendationTable: {
    paddingTop: '0.4rem !important',
  },

  renderMedDropDownWidth: {
    width: '350px',
  },
  dialogTitlePadding: {
    padding: '2px 5px 2px 15px !important',
  },
  closeBtnPadding: {
    padding: '25px 0px 0px 30px',
  },
  schedulesContainer: {
    flexWrap: 'nowrap',
    width: 'max-content !important',
    backgroundColor: '#EDEFF2',
  },
  scheduleTitle: {
    lineHeight: '1 !important',
    wordBreak: 'break-word',
    fontSize: '0.75rem !important',
  },
  scheduleDose: {
    cursor: 'pointer !important',
    lineHeight: '1',
  },
  scheduleItemWidth: {
    minWidth: '200px',
  },
  containerPadding: {
    padding: '0.5rem 0.2rem 0.5rem 1.5rem',
  },
  planLoading: {
    position: 'absolute',
    width: '15px !important',
    height: '15px !important',
    marginTop: '1px',
  },
  MoreVertIconFontSize: {
    fontSize: '1rem !important',
    padding: '0rem 0.1rem 0rem 0rem !important',
  },
  medicationUnits: {
    padding: '0px 0 7px 4px',
  },
  autoCompleteDropDowns: {
    width: '100% !important',
    height: 'auto !important',
    borderColor: '#CBCBCB !important',
  },
  medBox: {
    padding: '5px 10px 10px 30px !important',
  },
  rrdFormControl: {
    width: '210px',
  },
  formControlItemsPadding: {
    padding: '0.2rem 0.5rem !important',
    fontSize: '0.7rem !important',
  },
  checkBoxStyle: {
    marginLeft: '0.2rem !important',
    padding: '0rem 0.2rem !important',
  },
  totalDailyDose: {
    paddingTop: '0.3rem',
  },
  rrdButtons: {
    flexWrap: 'nowrap',
  },
  recommendedCheckCircle: {
    verticalAlign: 'text-bottom !important',
    height: '1rem !important',
    fill: 'green !important',
  },
  conditionsWordBreak: {
    wordBreak: 'break-all',
  },
  formulationDisplayName: {
    paddingTop: '0.1rem',
  },
  puSchedulePadding: {
    paddingBottom: '0.5rem',
  },

  doseTextFieldPadding: {
    padding: '3px 0 6px',
  },
  formControlWidth250: {
    width: '250px',
  },
  formControlWidth165: {
    width: '165px',
  },

  toxicityEvalBoxVal: {
    color: 'var(--color-text-primary) !important',
    fontSize: '0.7rem !important',
    fontWeight: 400,
    letterSpacing: '0.01071em !important',
    paddingLeft: '5px',
  },
  criteriaList: {
    padding: '0rem 0rem 0rem 0.1rem !important',
  },
  loadingEval: {
    padding: '0.3rem !important',
    width: '25px !important',
    height: '25px !important',
  },
  dialogContentStyle: {
    padding: '0 !important',
    // height: "23.6rem",
    overflow: 'auto',
    width: '100%',
  },
  prbdialogContentStyle: {
    padding: '0',
    minHeight: '4rem',
    overflow: 'hidden',
  },
  linearProgressContainer: {
    //  height: "450px",
    overflow: 'auto',
  },
  circularProgressBar: {
    padding: '1rem',
    width: '20px !important',
    height: '20px !important',
    color: 'var(--color-primary) !important',
  },
  dialogHeaderBox: {
    // height: "20rem",
    // overflowY: "auto",
  },
  rationaleDialogHeaderBox: {
    height: '24rem',
    overflowY: 'auto',
  },
  errorDataDialogHeaderBox: {
    maxHeight: '24rem',
    minHeight: '4rem !important',
    overflowY: 'auto',
    padding: '0.8rem 1rem 0.5rem 1.8rem !important',
    marginBottom: '0.5rem',
  },
  rationaleDialogHeader: {
    background: 'linear-gradient(180deg, #E1E1E1B3 0%, #F2F2F2 34%, #FFFFFF 78%, #FFFFFF 100%) 0% 0% no-repeat padding-box !important',
    height: '0.1rem !important',
  },
  editIcon: {
    fontSize: '0.78rem !important',
  },
  editDefIcon: {
    fontSize: '0.68rem !important',
  },
  noteIcon: {
    fontSize: '0.73rem !important',
  },
  iconFontSize: {
    fontSize: 'small',
  },
  visibleIconSize: {
    fontSize: '0.8rem !important',
    paddingTop: '0.3rem !important',
  },
  notValCompactMenuIcon: {
    fontSize: '14px !important',
    color: 'var(--color-primary)',
  },
  overideIcon: {
    fontSize: '0.9rem !important',
    color: '#757575',
  },
  rationaleIcon: {
    fontSize: '0.76rem !important',
    color: '#757575',
  },
  contextHelpIcon: {
    //paddingTop: '0.1rem',
    fontSize: '0.828rem !important',
    color: '#757575',
  },
  customMiniCard: {
    width: '100% !important',
    marginBottom: '1px !important',
  },
  cardsContentPadding: {
    padding: '0px 0px 0px 2px !important',
  },
  conditionsContainer: {
    display: 'flex !important',
    justifyContent: 'flex-end',
  },
  conditionsItem: {
    padding: '7px 4px 0px 0px !important',
    width: '40%',
  },
  evalTitleHeader: {
    maxWidth: '78%',
  },
  programCardContent: {
    padding: '8px 8px 0px 8px !important',
  },

  initialFlexwrap: {
    flexWrap: 'initial',
  },
  textAlignEnd: {
    textAlign: 'end',
  },
  textAlignStart: {
    textAlign: 'start',
  },
  notActiveIcon: {
    color: 'var(--color-primary) !important',
    paddingRight: '0.5rem',
  },
  helpOutlinePadding: {
    paddingRight: '0.5rem',
  },
  descleftHeader: {
    fontSize: '0.7rem !important',
    lineHeight: '1 !important',
    color: 'var(--color-highlight)',
  },

  pronunciationKeyboard: {
    verticalAlign: 'middle !important',
    height: '15px !important',
    fill: 'var(--color-primary) !important',
    cursor: 'pointer',
  },
  pointerCursor: {
    cursor: 'pointer !important',
    '&:hover': {
      cursor: 'pointer !important',
    },
  },
  contextualHelpContext: {
    minHeight: '3.5rem',
  },
  contextualHelpBox: {
    maxHeight: '25rem',
    marginBottom: '0.8rem !important',
    overflowY: 'auto',
  },
  contextualHelpContainer: {
    padding: '0.8rem 1rem 0.5rem 1.5rem !important',
    minHeight: '4rem !important',
  },
  contextualHelpHeader: {
    borderBottom: 'var(--color-border-light) solid 1px !important',
    padding: '0.5rem 0.5rem 0rem 1rem !important',
  },
  formControlDateTime: {
    width: '100% !important',
    marginTop: '1rem',
  },

  // Delete Card Component
  deleteCardContainer: {
    border: 'var(--color-primary) solid 0.1rem !important',
    width: '100%',
  },
  deleteButtonStyle: {
    justifyContent: 'space-around !important',
    display: 'flex !important',
    flexWrap: 'wrap',
    width: '100% !important',
    borderTop: 'var(--color-border-light) solid 1px',
  },
  deleteButtonWidth: {
    width: '50% !important',
    color: 'var(--color-primary) !important',
    textTransform: 'none',
  },
  headertext: {
    lineHeight: '16px !important',
    fontSize: '14px',
  },
  timestamp: {
    fontSize: '12px !important',
    color: '#999999',
  },
  confirmDelete: {
    paddingTop: '20px !important',
    lineHeight: '20px !important',
    fontSize: '15px',
  },
  customDeleteCard: {
    '& >div': {
      boxShadow: '0px 4px 8px 0px rgb(0 0 0 / 7%), 0px 6px 20px 0px rgb(0 0 0 / 7%) !important',
    },
  },
  deleteCardContent: {
    paddingBottom: '1rem',
  },
  emptyCardContent: {
    padding: '0.1rem 0.5rem !important',
    background: 'var(--color-background-subtle)',
  },
  confirmCardContent: {
    padding: '0rem 0rem 0.2rem 0.85rem !important',
  },
  emptyRecommendedCard: {
    width: '100% !important',
    border: '1px solid var(--color-border-light)',
  },
  emptyRecommendedCardContent: {
    paddingBottom: '1rem !important',
    background: 'var(--color-background-subtle)',
  },
  infoIconFont: {
    fontSize: '0.65rem !important',
  },
  schInfoIcon: {
    fontSize: '0.7rem !important',
  },
  medicationsBox: {
    width: '100% !important',
    display: 'block !important',
    marginBottom: '0rem',
  },
  medicationTextField: {
    width: '25%',
  },
  medicationsBoxDisplay: {
    display: 'block !important',
  },

  notesListContainer: {
    maxHeight: '200px !important',
    overflow: 'auto',
  },
  notesCarePlanText: {
    overflowWrap: 'break-word',
  },

  badgeContainer: {
    marginRight: '0.5rem !important',
  },
  badgeButton: {
    margin: '0px 0.5rem !important',
  },
  badgeButtonText: {
    textTransform: 'capitalize',
  },
  zeroPadding: {
    padding: '0px !important',
  },
  patientAccrodionBg: {
    backgroundColor: 'var(--color-background-subtle) !important',
  },
  patientAccrodionExpandIcon: {
    fontSize: '0.8rem !important',
  },
  zeroTopPadding: {
    paddingTop: '0px !important',
  },
  addPatientQuestionHeaderSection: {
    borderBottom: 'var(--color-border-light) solid 1px !important',
    padding: '0.5rem  !important',
  },
  addPatientDialogContent: {
    borderBottom: 'var(--color-border-light) solid 1px',
    minHeight: '5rem',
  },
  downloadDailyTaskReportContent: {
    borderBottom: 'var(--color-border-light) solid 1px',
    minHeight: '10rem',
  },
  addPatientInput: {
    display: 'none',
  },

  selectedFile: {
    padding: '12px',
  },
  addPatientTextField: {
    width: '320px',
  },
  JourneyComponentContainer: {
    borderBottom: '1px solid var(--color-border-light)',
  },
  journeyStageBox: {
    height: '0.85rem !important',
    width: '100%',
    fontSize: '0.6rem !important',
    margin: '0.3rem 0.8rem 0.3rem 0rem !important',
  },
  journeyMedDescription: {
    fontSize: '0.55rem!important',
    padding: '0.1rem 0.25rem 0.25rem 0rem',
    letterSpacing: '0.01071em',
    lineHeight: '1 !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
  },
  timeLine: {
    width: 'inherit !important',
  },

  multiProgramInfoContainer: {
    flexWrap: 'inherit',
    alignItems: 'center !important',
    width: '100%',
    paddingTop: '0.28rem',
  },
  multiProgramInfoHeader: {
    display: 'flex !important',
    width: '100%',
  },
  patientProfileContainer: {
    paddingTop: '1rem',
  },

  subHeaderProgramName: {
    marginTop: '0.06rem',
    fontSize: '0.8rem!important',
  },
  subHeaderStageBox: {
    paddingLeft: '20px',
  },
  programIcons: {
    marginRight: '0.35rem !important',
  },
  subHeaderStatusIcon: {
    padding: '2px 0px 5px 2px !important',
  },
  warningIcon: {
    fill: 'orange !important',
    fontSize: '15px !important',
    padding: '4px 5px 5px 0px !important',
  },
  staleBadge: {
    fontSize: '1rem !important',
  },
  subHeaderContainerBg: {
    padding: '0.8rem 0rem 0.2rem 0.8rem',
    backgroundColor: 'var(--color-body-background)',
  },
  subHeaderData: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0.1rem 0rem 0.4rem 0rem',
  },
  actionSelect: {
    maxWidth: '9rem !important',
    width: '100% !important',
    paddingTop: '0px',
    fontSize: '0.7rem !important',
    '&:before': {
      border: 'none !important',
    },
    '&:after': {
      border: 'none !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
  },
  stageLabel: {
    fontSize: '0.7rem !important',
    paddingTop: '0px',
    fontWeight: 500,
  },
  calculatorCard: {
    width: '100% !important',
    paddingLeft: '6px',
  },
  calAccordionSummary: {
    margin: '-1px 0px 0px 0px !important',
    paddingRight: '0px !important',
  },
  calculatorQuestionnarieTitleFont: {
    fontSize: '0.8rem',
  },
  nextActionSelect: {
    width: '6rem',
    paddingTop: '0px',
    fontSize: '0.7rem',
    '&:before, &:after, & .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
  },
  actionMenu: {
    fontSize: '0.7rem !important',
    color: 'var(--color-primary-dark) !important',
    padding: '0.15rem 0.6rem !important',
  },
  ptHistoryBox: {
    width: '100% !important',
    display: 'block',
  },
  tableHistoryHeader: {
    padding: '0.3rem 0.2rem 0rem 0.5rem !important',
    width: '100%',
  },
  tablePtHistory: {
    padding: '0.3rem 0.2rem 0.3rem 0.5rem !important',
    width: '35%',
  },
  tableCellPtHistory: {
    padding: '0.3rem 0.2rem 0rem 0rem !important',
    width: '15%',
  },
  titleSmall: {
    fontSize: '0.6rem !important',
    fontWeight: 500,
  },
  titleSmallBold: {
    fontSize: '0.6rem !important',
    fontWeight: '800 important',
  },
  tableCellDDHistory: {
    padding: '0.3rem 0rem 0.3rem 0rem !important',
    width: '15%',
  },
  tableCellChHistory: {
    padding: '0.3rem 0.2rem 0.3rem 0rem !important',
    width: '0%',
  },
  tableCellIconPtHistory: {
    padding: '0.3rem 0.25rem 0.3rem 0rem !important',
    width: '15%',
  },
  ptHistoryIconSize: {
    fontSize: '12px !important',
  },

  autoWidth: {
    width: 'auto',
  },
  formControlManageLab: {
    width: '240px',
  },
  selectEmptyFontSIze: {
    fontSize: '0.75rem',
  },
  manageLabButtonsContainer: {
    marginLeft: '25px',
  },
  manageLabAddButton: {
    padding: '0px !important',
    margin: '0px !important',
    fontSize: '13px !important',
    minWidth: 'auto !important',
    marginRight: '5px !important',
  },
  manageLabCancelButton: {
    paddingLeft: '5px !important',
    margin: '0px !important',
    fontSize: '13px !important',
    minWidth: 'auto !important',
  },
  programTargetFirstTableInputTitle: {
    width: '78%',
  },
  programTargetHeader: {
    color: 'var(--color-primary)',
    fontSize: '0.7rem !important',
    lineHeight: '1 !important',
  },
  programTargetFirstTableWidth: {
    width: '11%',
  },
  programTargetTargetHeader: {
    width: '11% !important',
    paddingLeft: '5px',
  },
  programTargetName: {
    display: 'flex !important',
    flexDirection: 'row',
  },
  programTargetEditIcon: {
    fontSize: '14px !important',
  },
  programTargetVisibilityIcon: {
    fontSize: '15px !important',
  },
  programTargetContainer: {
    padding: '0.2rem 0.3rem 0rem 0.3rem !important',
  },
  customCardTarget: {
    width: '100% !important',
    display: 'block !important',
    marginBottom: '0rem',
  },
  programTargetsConatiner: {
    padding: '16px',
  },
  programTargetsNames: {
    marginBottom: '0.8rem !important',
    flexWrap: 'nowrap',
    fontSize: '0.8rem!important',
  },
  targetDropDownPadding: {
    height: '1.8rem !important',
    fontSize: '0.75rem !important',
    '& .MuiOutlinedInput-input': {
      paddingRight: '1.8rem !important',
    },
  },
  breakWord: {
    wordBreak: 'break-word',
  },

  targetCardTimeZone: {
    padding: '0.7rem 0.05rem 0.5rem 0.05rem !important',
  },

  autoCompleteMedicineContainer: {
    lineHeight: '1 !important',
    paddingBottom: '0.25rem',
  },
  autoCompleteMedicineChips: {
    paddingTop: '0.3rem',
  },

  medIntoleranceContainer: {
    padding: '0px 5px 0px 3px !important',
  },
  medIntoleranceCard1: {
    width: '100% !important',
    marginBottom: '1rem',
  },
  medIntoleranceCard2: {
    width: '100% !important',
    marginBottom: '0.5rem',
  },

  programMedicationsButton: {
    backgroundColor: 'var(--color-paper) !important',
    color: 'var(--color-primary)',
  },

  programMedicationsButtonText: {
    whiteSpace: 'nowrap',
    textTransform: 'none',
  },
  whiteSpaceNowrap: {
    whiteSpace: 'nowrap',
  },
  programMedicationsCardContent: {
    padding: '0px 6px 2px 5px !important',
  },
  ProgramMedicationsNameContainer: {
    width: '97%',
  },
  ProgramMedicationsName: {
    color: 'var(--color-primary) !important',
    paddingTop: '0.1rem',
  },
  carePlanId: {
    width: '3%',
  },
  printInstructionsContainer: {
    marginBottom: '2px',
  },
  subMedicationImportedSource: {
    paddingTop: '10px',
  },
  srcAttributes: {
    cursor: 'pointer !important',
    fontSize: '0.75rem !important',
    paddingTop: '0px',
  },

  scheduleCarePlanTable: {
    padding: '0.5rem',
  },
  scheduleCarePlanContainer: {
    width: '100% !important',
    backgroundColor: '#edeff2 !important',
    border: '0.1rem solid var(--color-border-light)',
  },
  scheduleIcon: {
    fontSize: '0.75rem !important',
    lineHeight: '0.8rem !important',
    paddingRight: '0.1rem',
  },
  scheduleDoseInfo: {
    fontSize: '0.7rem !important',
    wordBreak: 'break-word',
    lineHeight: '0.8rem !important',
  },
  preferredScheduleCarePlan: {
    paddingTop: '0.6rem !important',
  },
  alternateSchedules: {
    cursor: 'pointer !important',
    lineHeight: '1',
  },
  questionHeaderSectionBg: {
    backgroundColor: 'var(--color-attention-bg)',
    color: 'var(--color-attention-text)',
  },

  filterChunkContainer: {
    borderTop: '1px solid var(--color-border-light) !important',
  },
  // Inactive/secondary — overrides global active style with subtle bg
  filterBtn: {
    padding: '0.1rem 0.25rem !important',
    minWidth: '2rem !important',
    height: '1.1rem',
    backgroundColor: 'var(--color-background-subtle) !important',
    color: 'var(--color-text-secondary) !important',
    borderColor: 'var(--color-border-medium) !important',
    opacity: '0.7 !important',
    '&:hover': {
      backgroundColor: 'var(--color-paper) !important',
      opacity: '1 !important',
    },
  },
  // Active — sizing only; bg/color from global (light: themes.tsx, dark: App.tsx darkModeStyles)
  // Typography inside must inherit button color (not the global dark-mode Typography white)
  filterActiveBth: {
    padding: '0.1rem 0.25rem !important',
    minWidth: '2rem !important',
    height: '1rem',
    '& .MuiTypography-root': {
      color: 'inherit !important',
    },
  },
  filterBorderBottom: {
    borderBottom: '1px solid var(--color-border-light) !important',
  },
  filterChunkItems: {
    overflowWrap: 'anywhere',
    flexWrap: 'initial',
    // height: '1rem !important'
  },
  filtersAccordionDetails: {
    padding: '0px 5px 0px 0px !important',
    display: 'block',
  },
  programCategory: {
    paddingLeft: '8px',
  },
  searchFieldBg: {
    backgroundColor: 'var(--color-paper) !important',
  },
  addPatientIconBtn: {
    margin: '0px 5px 0px 15px !important',
  },
  syncBtn: {
    margin: '0px 5px 0px 5px',
  },
  patientDataTableContainer: {
    maxHeight: '80vh',
  },
  patientListHeadersBorder: {
    borderRight: 'solid 0.01rem var(--color-border-light) !important',
    borderBottom: 'solid 0.01rem var(--color-border-light) !important',
    borderTop: 'solid 0.01rem #d3d3d3d1 !important',
  },
  patientsName: {
    color: 'var(--color-patient-link) !important',
    textDecoration: 'none',
  },
  overflowWrapAnywhere: {
    overflowWrap: 'anywhere',
  },
  overflowWrapBreakWord: {
    overflowWrap: 'break-word',
  },
  patientTextColor: {
    color: 'var(--color-patient-link)',
  },
  adornedEnd: {
    paddingRight: '2px !important',
  },
  navbar: {
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 1000,
    display: 'flow-root',
    width: '100vw',
  },
  pnfContainer: {
    paddingTop: '10% !important',
  },
  subHeaderPadding: {
    padding: '2px 0 2px 2px !important',
  },
  historySelect: {
    width: '8rem !important',
    paddingTop: '0px !important',
    fontSize: '0.7rem !important',
    '&:before, &:after, & .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '& .MuiSelect-select:focus': {
      background: 'none',
    },
  },
  historyMenu: {
    fontSize: '0.7rem !important',
    padding: '0.15rem 0.6rem !important',
  },
  programSelect: {
    minWidth: '10rem !important',
    width: 'auto !important',
    paddingTop: '0px !important',
    fontSize: '0.75rem !important',
    '&:before, &:after, & .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '& .MuiSelect-select:focus': {
      background: 'none',
    },
  },
  programMenu: {
    fontSize: '0.75rem !important',
    padding: '0.2rem 0.7rem !important',
  },
  programIcon: {
    fill: '#0cae0c !important',
    width: '15px !important',
    cursor: 'none !important',
    paddingLeft: '0.1rem !important',
    verticalAlign: 'middle',
  },
  resetPatientIcon: {
    opacity: '80% !important',
    color: 'var(--color-primary) !important',
    fontSize: '0.7rem !important',
  },
  medReconcileIcon: {
    opacity: '80% !important',
    fontSize: '18px !important',
    padding: '0.1px',
  },
  medReconcileDisabledIcon: {
    opacity: '80% !important',
    fontSize: '18px !important',
    padding: '0.1px !important',
    cursor: 'default !important',
    fill: '#80808091',
  },
  addLabReport: {
    width: '80% !important',
    fontSize: '0.65rem !important',
    backgroundColor: 'var(--color-paper) !important',
  },
  slideMenuTitle: {
    margin: '0px 2px 0px 0px !important',
    fontSize: '0.55rem !important',
    fontWeight: '400!important',
    lineHeight: '1.5 !important',
    color: 'var(--color-text-secondary) !important',
    whiteSpace: 'normal !important',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '60px',
  },
  // Active sidebar label — JSS !important beats dark-mode global Typography white
  slideMenuTitleActive: {
    margin: '0px 2px 0px 0px !important',
    fontSize: '0.55rem !important',
    fontWeight: '400!important',
    lineHeight: '1.5 !important',
    color: 'var(--color-primary) !important',
    whiteSpace: 'normal !important',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '60px',
  },
  patientTaskIcon: {
    fill: 'var(--color-text-secondary)',
    fontSize: '0.7rem !important',
    cursor: 'pointer !important',
    ':hover': {
      fill: 'var(--color-primary) !important',
    },
  },
  taskListFilter: {
    minWidth: '10rem',
    '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {
      padding: '0rem 0.2rem !important',
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.7rem !important',
      fontWeight: '500',
      color: 'var(--color-text-primary) !important',
    },
    '& .MuiAutocomplete-popupIndicator': {
      padding: '0rem !important',
    },
    '& .MuiInput-formControl': {
      marginTop: '0rem !important',
    },
    '& .MuiChip-root': {
      height: '1.2rem !important',
      padding: '0rem !important !important',
      border: '1px solid var(--color-border-medium) !important',
      background: 'var(--color-paper) !important',
      color: 'var(--color-text-primary) !important',
    },
    '& .MuiChip-label': {
      fontSize: '0.7rem !important',
      color: 'var(--color-text-primary) !important',
    },
    '& .MuiAutocomplete-option': {
      padding: '1px 8px !important',
    },
    '& .MuiChip-deleteIcon': {
      fontSize: '0.75rem !important',
    },
    '& .MuiAutocomplete-clearIndicator': {
      '& .MuiSvgIcon-root': {
        fontSize: '0.8rem !important',
      },
    },
  },
  taskTable: {
    width: '100% !important',
    backgroundColor: 'var(--color-paper) !important',
    padding: '0rem 0.5rem 0rem 0.2rem !important',
    overflow: 'auto !important',
  },
  taskCursor: {
    cursor: 'pointer !important',
  },
  taskAttemptBadge: {
    '& .MuiBadge-badge': {
      right: '-9px !important',
      top: '6px !important',
      backgroundColor: 'var(--color-text-secondary) !important',
      padding: '0.1rem !important',
      minWidth: '10px !important',
      height: '10px !important',
      fontSize: '0.4rem !important',
      cursor: 'pointer !important',
    },
  },
  taskNotesBox: {
    maxHeight: '15rem !important',
    overflowY: 'auto',
  },
  taskSchedule: {
    width: '6.5rem !important',
    fontSize: '0.6rem !important',
    backgroundColor: 'var(--color-paper) !important',
    '& .MuiOutlinedInput-input': {
      height: '1rem !important',
      padding: '2px 2px 2px 5px !important',
      fontSize: '0.7rem !important',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '0.75rem !important',
      padding: '0px 0.45rem 0px 0px !important',
      marginRight: '-1rem !important',
    },
    '& .MuiIconButton-root': {
      padding: '0px !important',
    },
  },
  taskNotes: {
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
  },
  taskInput: {
    color: 'var(--color-text-primary) !important',
    fontSize: '0.7rem !important',
    fontWeight: 410,
    letterSpacing: '0.01071em !important',
  },
  taskDetailsTooltip: {
    padding: '0rem 0rem 0.5rem 1rem',
  },
  taskActivityTooltip: {
    padding: '0.5rem',
    minHeight: '4rem',
    height: '10rem',
    overflow: 'auto',
  },
  taskHistoryTitle: {
    fontSize: '0.65rem !important',
  },
  diagnosisApproveBtn: {
    padding: '0.25rem 0.5rem !important',
  },
  diagnosisPlanBtn: {
    padding: '0.05rem 0.3rem !important',
    minWidth: '2rem !important',
    left: '0.4rem !important',
    height: 'auto !important',
    marginRight: '0.5rem !important',
    marginTop: '0.2rem !important',
    whiteSpace: 'nowrap !important',
    '& .MuiButton-startIcon': {
      marginRight: '0.15rem !important',
    },
    '&.Mui-disabled': {
      opacity: 0.5,
      color: 'var(--color-text-muted) !important',
      borderColor: 'var(--color-text-muted) !important',
    },
  },
  diagnosisPlanBtnLabel: {
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
    whiteSpace: 'nowrap !important',
    width: '100% !important',
    fontSize: '0.65rem !important',
    wordBreak: 'break-word',
    lineHeight: '0.6rem !important',
  },
  taskAddBtn: {
    padding: '0.05rem 0.3rem !important',
    minWidth: '2rem !important',
    left: '0.4rem !important',
    //  height: '1.2rem !important'
    '& .MuiTypography-root': { color: 'inherit !important' },
  },
  taskBadge: {
    backgroundColor: '#958c8c !important',
    color: 'white !important',
    left: '0.5rem !important',
    height: '16px !important',
    minWidth: '16px !important',
    width: '16px !important',
    fontSize: '0.65rem !important',
  },
  appSidebar: {
    flexGrow: 0,
    flexShrink: 0,
    minWidth: '70rem',
    maxWidth: '100rem',
    display: 'flex',
    flexDirection: 'row',
    zIndex: 2,
    width: 'auto !important',
  },
  appSidebarContent: {
    flex: 1,
  },
  appSidebarResizer: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: '6px',
    justifySelf: 'flex-end',
    cursor: 'col-resize',
    resize: 'horizontal',
    borderLeft: '0.12rem solid #e1e1e1',
  },
  taskSideBarIcon: {
    position: 'absolute',
    margin: `0rem 0rem 0rem -1.5rem !important`,
    fontSize: '1rem !important',
    fill: 'var(--color-text-secondary) !important',
    cursor: 'pointer',
    zIndex: 1000,
  },
  taskSideBarPanel: {
    padding: '0.1rem 0.5rem 0.1rem 0.3rem !important',
    minWidth: '1rem !important',
    width: 'max-content !important',
    left: '-0.2rem',
    border: 'none !important',
    borderTopRightRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
    borderTopLeftRadius: '1rem !important',
    borderBottomLeftRadius: '1rem !important',
    '& .MuiButton-startIcon': {
      marginRight: '0.3rem !important',
    },
  },
  taskHistoryVal: {
    color: 'var(--color-text-primary) !important',
    fontSize: '0.6rem !important',
    fontWeight: '410 !important',
    letterSpacing: '0.01071em',
  },
  autoFitLabel: {
    flex: 1,
    whiteSpace: 'nowrap !important',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
  },
  taskSlidebarMenu: {
    fontSize: '1rem !important',
    fill: 'var(--color-text-secondary) !important',
    '&:hover': {
      fill: 'var(--color-primary) !important',
    },
  },
  // Active sidebar icon — JSS !important ensures primary color in both light and dark mode
  taskSlidebarMenuActive: {
    fontSize: '1rem !important',
    fill: 'var(--color-primary) !important',
  },
  taskPendingBadge: {
    '& .MuiBadge-badge': {
      top: '-3px !important',
      right: '1px !important',
      height: '14px !important',
      padding: '4px !important',
      color: 'var(--color-text-secondary) !important',
      fontSize: '0.55rem !important',
    },
  },
  jsonViewBox: {
    padding: '0.5rem 0rem 0rem 0rem',
    '& div': {
      backgroundColor: 'var(--color-paper) !important',
    },
    '& span': {
      fontSize: '0.7rem !important',
      lineHeight: '1rem !important',
      color: 'var(--color-text-primary) !important',
    },
    // Override react-json-view-lite default colors for dark mode compatibility
    '& .json-view': {
      backgroundColor: 'var(--color-paper) !important',
      color: 'var(--color-text-primary) !important',
    },
    '& .json-view--property': {
      color: 'var(--color-link) !important',
    },
    '& .json-view--string': {
      color: '#98c379 !important',
    },
    '& .json-view--number': {
      color: '#d19a66 !important',
    },
    '& .json-view--boolean': {
      color: '#56b6c2 !important',
    },
    '& .json-view--null': {
      color: '#e06c75 !important',
    },
  },
  disabledBtn: {
    backgroundColor: 'var(--color-background-subtle) !important',
    color: 'var(--color-text-primary) !important',
    borderColor: 'var(--color-border-medium) !important',
    cursor: 'not-allowed',
  },
}

export default stylesheet
